export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) {
    const { LocalConfigurationStore, Debug } = stores()
    const event = useRequestEvent()
    if (event?.context.error) {
      showError({
        message: event?.context.error.message,
        statusMessage: event?.context.error.stack,
      })
    }
    LocalConfigurationStore.value = event?.context.localContentConfigurations
    Debug.value = event?.context?.debug
  }
})
